import { render, staticRenderFns } from "./AmnioOperativeNote.vue?vue&type=template&id=22999422&"
import script from "./AmnioOperativeNote.vue?vue&type=script&lang=js&"
export * from "./AmnioOperativeNote.vue?vue&type=script&lang=js&"
import style0 from "./AmnioOperativeNote.vue?vue&type=style&index=0&id=22999422&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports